import { render, staticRenderFns } from "./new-doc-box.vue?vue&type=template&id=38debaf2&"
import script from "./new-doc-box.vue?vue&type=script&lang=js&"
export * from "./new-doc-box.vue?vue&type=script&lang=js&"
import style0 from "./new-doc-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,NewDocIcon: require('/usr/src/app/components/account/common-elements/icons/new-doc-icon.vue').default})
